import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import { ToastProvider } from "@rageeb/frontend-lib";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { authConfig } from "./auth-config";
import { LogoutLoading } from "./components/LogoutLoading";
import { LogoutLoadingProvider } from "./contexts/logout-loading-context";
import { AppRouter } from "./router";
import { setupApiInterceptor } from "./services/api";

const oktaAuth = new OktaAuth({
	...authConfig.oidc,
	clientId: authConfig.oidc.clientId ?? "",
	issuer: authConfig.oidc.issuer ?? "",
});

setupApiInterceptor(oktaAuth);

const App = () => {
	const navigate = useNavigate();

	const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
		navigate(toRelativeUrl(originalUri || "/", window.location.origin));
	};

	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnReconnect: false,
				refetchOnWindowFocus: false,
				retry: false,
			},
		},
	});

	return (
		<Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
			<QueryClientProvider client={queryClient}>
				<LogoutLoadingProvider>
					<ToastProvider>
						<AppRouter />
						<LogoutLoading />
					</ToastProvider>
				</LogoutLoadingProvider>
			</QueryClientProvider>
		</Security>
	);
};

export { App };
